export const TOGGLE_MENU = 'TOGGLE_MENU'
export const TOGGLE_FOOTER = 'TOGGLE_FOOTER'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const SUPPORTS_SHOW = 'SUPPORTS_SHOW'
export const SUPPORTS_TECHNO_AUTRES = 'SUPPORTS_TECHNO_AUTRES'

export const IGN_LAYER_SET_CURRENT = 'IGN_LAYER_SET_CURRENT'

export const QUESTIONNAIRE_SETDETAILS = 'QUESTIONNAIRE_SETDETAILS'
export const QUESTIONNAIRE_UNSET = 'QUESTIONNAIRE_UNSET'
